import { ref } from 'vue';

import { type SsoEmailLookupMatchType } from '@/utils/ssoEmailLookup';

/**
 * Shared reactive state for the "your team uses SSO" prompt: the matched org
 * and whether the prompt is shown. Used by both the pre-auth login/registration
 * flow ([[useSsoEmailPrompt]]) and the post-Google-auth flow
 * ([[useGoogleSsoPostLoginPrompt]]).
 */
export default function useSsoPromptState() {
  const ssoEmailMatch = ref<SsoEmailLookupMatchType | null>(null);
  const isPromptVisible = ref(false);

  function resetPrompt() {
    isPromptVisible.value = false;
    ssoEmailMatch.value = null;
  }

  return { ssoEmailMatch, isPromptVisible, resetPrompt };
}
